import React from 'react';

export default function StepSchneller() {
  return (
    <div className="ob-step-enter ob-schneller">
      <p className="ob-schneller__intro">Du hast gerade&nbsp;…</p>

      <div className="ob-schneller__vergleich">
        <div className="ob-schneller__zeile ob-schneller__zeile--vorher">
          <span className="ob-schneller__label">BISHERIGE BEWERBUNG</span>
          <span className="ob-schneller__wert">~ 1 Stunde / Bewerbung</span>
        </div>
        <div className="ob-schneller__zeile ob-schneller__zeile--nachher">
          <span className="ob-schneller__label">MIT CVFLOW / DEIN TEMPO</span>
          <span className="ob-schneller__wert">~ 2 Minuten / Bewerbung</span>
        </div>
      </div>
    </div>
  );
}
